"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackArrow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M1 7H16M1 7L7 1M1 7L7 13", stroke: "black", strokeWidth: strokeWidth }, void 0) }, void 0));
};
exports.BackArrow = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 16 14' });
//# sourceMappingURL=BackArrow.js.map